var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-code",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "pre",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentContent !== "",
                          expression: "currentContent !== ''",
                        },
                      ],
                    },
                    [
                      _c("code", {
                        staticClass: "hljs",
                        domProps: {
                          innerHTML: _vm._s(_vm.highlightContent),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentLang !== "",
                          expression: "currentLang !== ''",
                        },
                      ],
                      staticClass: "code-lang",
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.currentLang))])]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Sprache")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentLang,
                                  expression: "currentLang",
                                },
                              ],
                              attrs: {
                                type: "text",
                              },
                              domProps: {
                                value: _vm.currentLang,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentLang = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Quelltext")) +
                                "\n                    "
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentContent,
                                  expression: "currentContent",
                                },
                              ],
                              domProps: {
                                value: _vm.currentContent,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentContent = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Quelltext-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }